module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "image1",
      "src": "images/box.jpg"
    }
  })])]), _vm._v(" "), _c('td', [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "foreword"
    }
  }, [_vm._v("   Foreword")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticStyle: {
      "color": "#585858"
    }
  }, [_vm._v("T")])]), _vm._v("WENTY-FIVE YEARS TO the day after he was lost, my brother, Lt Ralph Foulks of the US Navy, finally came home from Vietnam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our lives changed forever on 5 January 1968 when Ralph’s plane was shot down, but our destinies took another twist on 5 January 1993 when the US Navy informed us that Ralph’s remains had been positively identified and that he was now home. We never knew what had happened to him. Life went through phases during those many years. Until the war ended there was always the possibility that Ralph – ‘Skip’ to his buddies but always ‘Bubby’ to me – was alive. Even after the war was over, and the POWs came home, there were countless times when we said “what if?” when bits of news or movies would come out suggesting that POWs remained hidden in remote areas of Vietnam. That phase seemed to go on forever. Until he came home we never knew, but we always hoped there was some chance that he was alive, far-fetched as that idea may have been.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image1",
      "src": "images/page7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Colleen Ijuin’s favourite photo of her and her brother Ralph. One of the last times she saw him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For many families the military knocking on the door had a sad finality and they knew their loved ones were dead. But for the families of those missing in action the haunting began. We carefully packed Red Cross POW care packages, diligently following the guidelines of what could be enclosed along with his favourite candy. It was as if the better the box was packed then the surer we would be that he got it. It was always painful to have the box come back marked ‘undeliverable’. At the holiday season the Red Cross films of POW camps had us glued to the TV hoping that we would see Ralph and that the returned care packages were just a terrible mistake. I remember a letter from Ralph’s wife saying she "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("was sure she had seen him. Ralph had married just two months before deploying.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image1",
      "src": "images/page8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A typical all-American scene. Ralph Foulks, with Colleen (the youngest) and his other sister Debbie on the trolley.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the time Ralph went missing I replayed the scenes of our times together over and over in my mind, trying to keep him alive. During the years of having a loved one missing in action the recollections take on a greater-than-life importance and your very existence becomes just a period of endurance. Ralph’s life was but one, and as deep as that hole was in our lives there were hundreds, if not thousands, of other families enduring the same. I’m sure the recollections are played over and over again in thousands of minds. Until the day they come home. And then a new phase begins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, we can take flowers to Ralph’s grave in Barrancas National Cemetery. We know that he is dead and although we still don’t know the details of what happened to Skip we have him home. For the families who never have that new phase beginning it must be like torture if I think about it now. To have a loved one missing in action means you never give up hope. You just endure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having those who were found remembered in this book helps sustain those who bear that loss, and having them come home helps to heal. As you read here about those who were lost, including some who are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("still")]), _vm._v(" lost, the fact that the reader sees their names and remembers them brings a great deal of comfort to those left behind. I am so grateful to Andy Saunders for bringing back the missing as well as bringing them back from being forgotten. Each face here represents so many who still need to be remembered and found.")]), _vm._v(" "), _c('p', {
    staticClass: "imageleft"
  }, [_c('img', {
    attrs: {
      "alt": "image1",
      "src": "images/sign8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("Colleen Ijuin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Sister of Lt Ralph Eugene Foulks Jr. US Navy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Lost in action over Vietnam 5 January 1968")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f05f049","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 72
// module chunks = 0